export default __webpack_public_path__ + "static/media/nodejs_logo.08ed4103.svg";